import { useEffect, useState } from 'react';

const hardCodedLocale = 'en';

export function useDetectBrowserTranslation(): {
  browserTranslation: 'microsoftEdge' | string | null;
} {
  const chromeFirefoxSafariBrowserTranslation =
    useDetectChromeFirefoxSafariBrowserTranslation();
  const microsoftEdgeBrowserTranslation =
    useDetectMicrosoftEdgeBrowserTranslation();
  const browserTranslation =
    microsoftEdgeBrowserTranslation ?? chromeFirefoxSafariBrowserTranslation;

  return { browserTranslation };
}

function useDetectMicrosoftEdgeBrowserTranslation() {
  const [browserTranslation, setBrowserTranslation] = useState<
    'microsoftEdge' | null
  >(null);
  useEffect(() => {
    const title = document.getElementsByTagName('title')[0];
    const detectTranslationMicrosoftEdge = () => {
      if (title?.hasAttribute('_msttexthash')) {
        setBrowserTranslation('microsoftEdge');
      } else {
        setBrowserTranslation(null);
      }
    };
    detectTranslationMicrosoftEdge();

    const observer = new MutationObserver(detectTranslationMicrosoftEdge);
    observer.observe(title, {
      attributes: true,
      attributeFilter: ['_msttexthash'],
      childList: false,
      characterData: false,
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return browserTranslation;
}

function useDetectChromeFirefoxSafariBrowserTranslation() {
  const [browserTranslation, setBrowserTranslation] = useState<string | null>(
    null,
  );
  const htmlLang = useHtmlLang();
  useEffect(() => {
    if (htmlLang !== hardCodedLocale) {
      setBrowserTranslation(htmlLang);
    } else {
      setBrowserTranslation(null);
    }
  }, [htmlLang]);

  return browserTranslation;
}

export function useHtmlLang() {
  const [htmlLang, setHtmlLang] = useState<string | null>(null);
  useEffect(() => {
    const detectLang = () => {
      const lang = document.documentElement.lang;
      if (lang !== htmlLang) {
        setHtmlLang(lang);
      }
    };
    // Initial check
    detectLang();

    // Observe changes to the html element's attributes
    const observer = new MutationObserver(detectLang);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['lang'],
      childList: false,
      characterData: false,
    });

    return () => {
      observer.disconnect();
    };
  }, [htmlLang]);
  return htmlLang;
}
